<template>
    <div class="fluid fill-height fill-width" style="width: 100%;flex: 1 1 auto;position: relative;">
        <div class="temporary-container" style="right: 0px;height: 100%;" v-bind:style="{right: (fullWidth) ? '0' : '500px'}">
            <p class="display-1">
                {{$t("Temporal permission ended")}}
            </p>
            <div>
                <v-btn round center color="primary" @click="requestExtension" :loading="requesting">{{$t("Request permission extension")}}</v-btn>
            </div>
            <div v-if="register">
                <p class="title mt-4">
                    {{$t("You need to be a registered user in order to request a permission extension")}}
                </p>
                <v-btn round center color="primary" @click="goRegister">{{$t("Register")}}</v-btn>
            </div>
            <div v-if="false">
                <p class="title">
                    {{$t("You can't access anymore? Now it's your turn to use WeLicense to protect your files!")}}
                </p>
                <div>
                    <v-btn round center color="success" dark @click="goRegister">{{$t("Register Now")}}</v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { VBtn } from 'vuetify/lib'
    import FilesRepository from '../repositories/FilesRepository';

    export default {
        name: 'TemporalPermissionsEnded',
        components: {
            VBtn, FilesRepository
        },
        props: {
            fullWidth: Boolean,
            file: Object,
            hash: String,
            token: String
        },
        data () {
            return {
                requesting: false,
                register: false
            }
        },
        methods: {
            goRegister() {
                this.$root.$emit('show-register');
            },
            requestExtension() {
                if (!this.$user) {
                    this.register = true;
                } else {
                    this.requesting = true;
                    FilesRepository.requestAccess(this.hash, this.token)
                        .then((response)=>{
                            this.$root.$emit('show-snackbar', {message: this.$t('Access request sent successfully!'), color: 'success', timeout: 6000 });
                        })
                        .catch((err)=>{
                            let message = this.$t('Error sending access request to owner');
                            if (err.response && err.response.data && err.response.data.message) {
                                message = err.response.data.message;
                            }
                            this.$root.$emit('show-snackbar', {message: message, color: 'error', timeout: 6000 });
                        })
                        .finally(()=>{
                            this.requesting = false;
                        })
                }
            }
        }
    };
</script>

<style scoped>
    .temporary-container {
        left: 0;
        top: 0;
        bottom: 0;
        position: absolute;
        padding-top: 10px;
    }
</style>
